module.exports = __webpack_public_path__ + "static/media/pro-noti-center-tips.f8b62c87.png";